import Hero from "../components/ai-teens/hero";
import Footer from "../components/footer/footer";
import Scope from "../components/ai-teens/scope";
import Background from "../components/ai-teens/background";
import HowCanHelp from "../components/ai-teens/howCanHelp";
import Apply from "../components/ai-teens/apply";

export default function AIteens() {
  return (
    <>
      <Hero />
      <Scope />
      <Background />
      <HowCanHelp />
      <Apply />
      <Footer />
    </>
  );
}